var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "general-message",
          class: [
            _vm.type && "general-message--type-" + _vm.type,
            {
              "general-message--auto": !!_vm.delay,
            },
          ],
          on: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _c("div", {
            staticClass: "general-message__text",
            domProps: { innerHTML: _vm._s(_vm.message) },
          }),
          _vm._v(" "),
          !_vm.stick
            ? _c(
                "button",
                {
                  staticClass: "general-message__close",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_c("SVGClose")],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }